import getMaxFavoriteSuggestionCounts from './getMaxFavoriteSuggestionCounts';
import FavoriteSuggestion from '../../types/FavoriteSuggestion';
import FavoriteSuggestionType from '../../types/FavoriteSuggestionType';
import { favoritesStore } from 'owa-favorites';
import searchCache from 'owa-recipient-cache/lib/selectors/searchCache';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { isFeatureEnabled } from 'owa-feature-flags';
import isValidEmailAddress from 'owa-readwrite-recipient-well/lib/utils/isValidEmailAddress';

export default function getFavoritePeopleSuggestions(findText: string): FavoriteSuggestion[] {
    const existingFavoritePeople: { EmailAddress: EmailAddressWrapper }[] = [];
    const emailsInStore: string[][] = isFeatureEnabled('tri-favorites-roaming')
        ? [...favoritesStore.outlookFavoritePersonas.values()].map(f => f.allEmailAddresses)
        : [...favoritesStore.favoritesPersonaNodes.values()].map(f => f.allEmailAddresses);

    emailsInStore.forEach(emailsArray => {
        existingFavoritePeople.push(
            ...emailsArray.map(emailAddress => ({
                EmailAddress: {
                    EmailAddress: emailAddress,
                },
            }))
        );
    });

    const maxPeopleSuggestions = getMaxFavoriteSuggestionCounts().people;
    const topRecipients = searchCache(
        findText,
        maxPeopleSuggestions /* numberOfResults */,
        existingFavoritePeople /* recipientsToExclude */,
        ['PrivateDL', 'PublicDL', 'GroupMailbox'] /* mailboxTypesToExclude */
    ).filter(recipient => {
        const address = recipient.EmailAddress && recipient.EmailAddress.EmailAddress;
        return address && isValidEmailAddress(address);
    });

    return topRecipients.map(recipient => {
        return {
            data: recipient,
            id: recipient.PersonaId.Id,
            type: FavoriteSuggestionType.Persona,
            relevance: 0 /* Relevance scores will be supplied by providers in the future */,
        };
    });
}
